import { setBearerToken } from '@/http'

export const setHeaderToken = token => setBearerToken(token)
export const getLocalToken = () => localStorage.getItem('token')
export const deleteLocalToken = () => localStorage.removeItem('token')
export const setLocalToken = token => localStorage.setItem('token', token)

export const getLocalTokenChat = () => localStorage.getItem('token-chat')
export const setLocalTokenChat = token => localStorage.setItem('token-chat', token)

export const getTheme = () => localStorage.getItem('theme') || 'light'
export const setTheme = theme => localStorage.setItem('theme', theme)
